import React, { useState } from "react";
import { useFormik } from "formik";
import logo from "../../assets/images/common/nefos-logo-new.png";
import logoIcon from "../../assets/images/common/nefos.png";
import { useNavigate } from "react-router-dom";
import { CiMail } from "react-icons/ci";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { getEmailRequest } from "../../api/actions/auth";
import toast from "react-hot-toast";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { IoIosArrowRoundBack } from "react-icons/io";
import SimpleBackdrop from "../../components/common/Common/Buttonloader";

const ForgotPassword = () => {
  const [buttonloader, setButtonloader] = useState(false);
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      user_email: "",
    },
    // validationSchema,
    onSubmit: (values) => {
      setButtonloader(true);
      getEmailRequest(values)((response) => {
        if (response?.status) {
          toast.success("Email send successfully and please check the mail!");
          formik.resetForm();
        } else {
          toast.error(response?.message);
        }
        setButtonloader(false);
      });
    },
  });

  return (
    <div className="login-main">
      <div className="login-header">
        <img style={{ width: "100px" }} src={logo} alt="logo" />
        <AiOutlineQuestionCircle style={{ fontSize: "20px" }} />
      </div>
      <div className="login-container">
        <Container>
          <div className="login-box-container">
            <Row>
              <div className="login-box">
                <div className="login-title">
                  <div
                    style={{
                      backgroundColor: "white",
                      width: "60px",
                      height: "60px",
                      borderRadius: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img style={{ width: "50px" }} src={logoIcon} alt="logo" />
                  </div>{" "}
                  <h3>Forgot password</h3>
                </div>
                <div className="login-input-box">
                  <Form onSubmit={formik.handleSubmit}>
                    <div className="login-input-field">
                      <CiMail />

                      <Form.Control
                        type="text"
                        placeholder="Email id"
                        name="user_email"
                        onChange={formik.handleChange}
                        value={formik.values.user_email}
                      />
                    </div>

                    <div className="login-submit-btn">
                      <Button disabled={buttonloader} type="submit">
                        {buttonloader ? <SimpleBackdrop /> : "Submit"}
                      </Button>
                    </div>
                  </Form>
                </div>
                <div
                  className=""
                  onClick={() => navigate("/login")}
                  role="button"
                  style={{ color: "#fff" }}
                >
                  <IoIosArrowRoundBack />
                  Login
                </div>
              </div>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default ForgotPassword;
